"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "RatingSqliteHandler", {
    enumerable: true,
    get: function() {
        return RatingSqliteHandler;
    }
});
const _ratinggeneralhandler = require("./rating.general.handler");
const _decimalsqlitehandler = require("~/db/field-handler/handlers/decimal/decimal.sqlite.handler");
let RatingSqliteHandler = class RatingSqliteHandler extends _decimalsqlitehandler.DecimalSqliteHandler {
    constructor(...args){
        super(...args), this.ratingGeneralHandler = new _ratinggeneralhandler.RatingGeneralHandler(), this.parseUserInput = this.ratingGeneralHandler.parseUserInput, this.filterLt = this.ratingGeneralHandler.filterLt, this.filterLte = this.ratingGeneralHandler.filterLte, this.filterGte = this.ratingGeneralHandler.filterGte;
    }
};
